// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "main[data-v-3a9cdf19]{min-height:calc(100vh - 74px)}", ""]);
// Exports
module.exports = exports;
